"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.rehydrateStateReducer = exports.rehydrateState = exports.default = exports.ACTION = void 0;
var _localStore = _interopRequireDefault(require("./localStore"));
var _deepmerge = _interopRequireDefault(require("../helpers/deepmerge"));
var ACTION = exports.ACTION = '@@REHYDRATE_STATE';

// $FlowFixMe: Add types
var rehydrateStateReducer = exports.rehydrateStateReducer = function rehydrateStateReducer(reducer) {
  return function (state, action) {
    if (action.type === ACTION && action.state) {
      return (0, _deepmerge.default)(state, action.state);
    }
    return reducer(state, action);
  };
};
var rehydrateState = exports.rehydrateState = function rehydrateState() {
  return {
    type: ACTION,
    state: _localStore.default.get()
  };
};
var defaultOpts = {
  keys: []
};
var syncLocalStorage = function syncLocalStorage(_temp // $FlowFixMe: Add types
) {
  var _ref = _temp === void 0 ? defaultOpts : _temp,
    keys = _ref.keys;
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var state = store.getState();
        _localStore.default.set(keys.reduce(function (acc, key) {
          var payload = state[key];
          var data = payload;
          acc[key] = data || {};
          return acc;
        }, {}));
        return result;
      };
    };
  };
};
var _default = exports.default = syncLocalStorage;